export const ADD_SHIPPING = 'ADD_SHIPPING'